import { Grid, withStyles, withWidth } from '@material-ui/core';
import { isWidthUp } from '@material-ui/core/withWidth';
import MasonryLayout from 'components/common/MasonryLayout';
import mixpanel from 'components/common/mixpanel';
import toJS from 'components/common/toJS';
import { resolveLocationNameById } from 'components/common/utils';
import FirstTimeMiniWidget from 'components/dashboard/location/FirstTimeMiniWidget';
import LastSeenWidget from 'components/dashboard/location/LastSeenWidget';
import HighPotentialCustomers from '../sales/HighPotentialCustomers';
import TotalCustomersMiniWidget from 'components/dashboard/location/TotalCustomersMiniWidget';
import useSettingsChangeActionDispatcher from 'components/dashboard/location/useSettingsChangeActionDispatcher';
import WeatherMiniWidget from 'components/dashboard/location/WeatherMiniWidget';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getDefaultLocationId, getLocations, getUserTimezone } from 'reducers/auth';
import { actions, getReport, getRequestDate, isReportFetching } from 'reducers/dashboard/sales/summary';
import AiSummaryWidget from 'components/dashboard/location/AiSummaryWidget';
import MiniWidget from '../common/MiniWidget';
import FirstTimeReturningMembersWidget from '../sales/FirstTimeReturningMembersWidget';
import { percentageOfTotal } from '../common/utils';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
    flexShrink: 0,
  },
  miniWidgetsContainer: {
    marginBottom: theme.spacing(4),
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gridGap: theme.spacing(4),
  },
});

function LocationDashboardSplash2o({
  classes,
  width,
  location,
  history,
  reportRequest,
  isFetching,
  requestDate,
  report,
  userTimezone,
  defaultLocationId,
}) {
  const mixpanelTrack = useCallback(
    (requestDate, timezone, period, locationId) => {
      mixpanel((mp) =>
        mp.track('Location dashboard', {
          timezone,
          period,
          locationId,
          locationName: resolveLocationNameById(locationId),
        })
      );
      reportRequest(requestDate, timezone, period, locationId);
    },
    [reportRequest]
  );
  const [period, timezone] = useSettingsChangeActionDispatcher(
    location,
    history,
    userTimezone,
    mixpanelTrack,
    defaultLocationId
  );

  let columns = 1;
  if (isWidthUp('md', width)) {
    columns = 2;
  }
  if (isWidthUp('lg', width)) {
    columns = 3;
  }

  return (
    <Grid item className={classes.grow}>
      <div className={classes.miniWidgetsContainer}>
        <TotalCustomersMiniWidget defaultLocationId={defaultLocationId} />
        <MiniWidget
          isFetching={isFetching}
          title="Members"
          value={report?.summary?.members}
          rightHelperText={percentageOfTotal(report?.summary?.members, report?.summary?.total)}
          textContainerAlignItems="baseline"
        />
        <FirstTimeMiniWidget defaultLocationId={defaultLocationId} />
        <MiniWidget
          isFetching={isFetching}
          title="Returning non members"
          value={report?.summary?.returningNonMembers}
          rightHelperText={percentageOfTotal(report?.summary?.returningNonMembers, report?.summary?.total)}
          textContainerAlignItems="baseline"
        />
        <WeatherMiniWidget defaultLocationId={defaultLocationId} />
      </div>
      <MasonryLayout columns={columns} gap={32}>
        <FirstTimeReturningMembersWidget
          timezone={timezone}
          period={period}
          isFetching={isFetching}
          requestDate={requestDate}
          report={report}
          minDaily
        />
        <LastSeenWidget defaultLocationId={defaultLocationId} />
        <HighPotentialCustomers
          key="highPotentialCustomers"
          isFetching={isFetching}
          requestDate={requestDate}
          report={report}
        />
        <AiSummaryWidget
          key="aiSummary"
          history={history}
          location={location}
          userTimezone={userTimezone}
          defaultLocationId={defaultLocationId}
        />
      </MasonryLayout>
    </Grid>
  );
}

function mapStateToProps(state) {
  return {
    defaultLocationId: getDefaultLocationId(state),
    availableLocations: getLocations(state),
    userTimezone: getUserTimezone(state),
    isFetching: isReportFetching(state),
    report: getReport(state),
    requestDate: getRequestDate(state),
  };
}

export default withRouter(
  connect(mapStateToProps, {
    reportRequest: actions.reportRequest,
  })(withStyles(styles)(withWidth()(toJS(LocationDashboardSplash2o))))
);
